import { useEffect, useState } from 'react'
import { AxiosResponse } from 'axios'
import axiosInstance from '@config/axios'
import { serverPath } from '@constants/api-endpoints'
import { errorMapper } from '@utils/errorMapper'
import { ErrorMessages } from '@constants/errors'
import { useMessage } from '@hooks/useMessage'
import moment from 'moment'
import { ITableState } from '@utils/sort'
import { TableDataResponse } from '@interfaces/table.interface'

interface Props {
  crmId?: string
  dates: [moment.Moment, moment.Moment]
  pagination?: ITableState
}

export interface ICrmPayment {
  amount: number
  balance: number
  createdAt: string
  description: string
  id: string
  name: string
  type: string
}

const useCrmPaymentsApi = ({ crmId, dates, pagination }: Props) => {
  const { error } = useMessage()
  const [isLoading] = useState(false)
  const [result, setResult] = useState<TableDataResponse<ICrmPayment>>()
  const getData = async () => {
    if (crmId) {
      try {
        const { data }: AxiosResponse<TableDataResponse<ICrmPayment>> = await axiosInstance.get(
          serverPath.CRM_PAYMENTS + crmId,
          {
            params: {
              dates: [
                dates[0].format('YYYY-MM-DDTHH:mm:ss[Z]'),
                dates[1].format('YYYY-MM-DDTHH:mm:ss[Z]'),
              ],
              pageSize: pagination?.pagination ? pagination.pagination.pageSize : null,
              page: pagination?.pagination ? pagination.pagination.current : null,
              sort: pagination?.sort?.sort ?? null,
              field: pagination?.sort?.field ?? null,
            },
          },
        )
        setResult(data)
      } catch (e) {
        error(errorMapper(ErrorMessages.GET_DATA, e), ErrorMessages.SERVER_ERROR)
      }
    }
  }

  useEffect(() => {
    getData().then()
  }, [crmId, dates, pagination])

  return { result: result, isLoading: isLoading ?? false }
}

export default useCrmPaymentsApi
